<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import snackbarMixin from '@/mixins/snackbar';
import { result } from 'lodash';
import MeasureNoteDialog from './MeasureNoteDialog';

export default {
  name: 'Question',
  components: {
    MeasureNoteDialog,
  },
  mixins: [snackbarMixin],
  props: {
    question: {
      type: Object,
      required: true,
    },
    privacyAuditId: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      answers: [],
      measures: [],
      measureItemId: null,
      measureItemNote: null,
      localDisabled: false,
      isMeasureListProcessing: false,
      isMeasureNoteDialogDisplayed: false,
    };
  },
  created() {
    this.localDisabled = this.disabled;
  },
  mounted() {
    axios.get(`/privacyAudit/${this.privacyAuditId}/answer`, {
      params: { questionId: this.question.id },
    })
      .then((response) => {
        this.answers = response.data;
      })
      .catch(() => {
        console.log('error');
      });

    this.readMeasures();
  },
  methods: {
    ...mapActions('taskList', ['getAll']),
    toggleSelection(answerId) {
      const self = this;
      this.isMeasureListProcessing = true;

      axios.post(`/privacyAudit/${this.privacyAuditId}/answer`, {
        answerId,
      })
        .then(() => {
          this.getAll();
          axios.get(`/privacyAudit/${this.privacyAuditId}/measureItem`, {
            params: { questionId: this.question.id },
          })
            .then((response) => {
              this.measures = response.data;
            })
            .catch((error) => {
              console.log('error', error);
            })
            .finally(() => {
              this.isMeasureListProcessing = false;
            });
        })
        .catch((response) => {
          const message = result(response, 'data.data.error', 'Die Auswahl konnte nicht gespeichert werden. Bitte laden Sie die Seite neu.');
          self.showErrorMessage(message);
        });
    },
    onEditMeasureNote(measureItem) {
      this.readMeasures()
        .then(() => {
          this.measureItemId = measureItem.id;
          this.measureItemNote = this.measures
            .find(it => it.id === this.measureItemId)
            .note;
          this.isMeasureNoteDialogDisplayed = true;
        })
        .catch((error) => {
          console.log('error', error);
        });
    },
    readMeasures() {
      return axios.get(`/privacyAudit/${this.privacyAuditId}/measureItem`, {
        params: { questionId: this.question.id },
      })
        .then((response) => {
          this.measures = response.data;
        })
        .catch((error) => {
          console.log('error', error);
        });
    },
    onNoteSubmit() {
      this.readMeasures();
    },
  },
};
</script>

<template>
  <div>
    <v-container fluid grid-list-lg pt-2 pa-2>
      <v-layout row wrap>
        <v-flex md12>
          {{ question.orderNumber }}) &nbsp; {{ question.text }}
        </v-flex>
      </v-layout>

      <div v-for="answer in answers" :key="(answer.id)">
        <v-layout row wrap>
          <v-flex md12 style="height: 45px;">
            <v-checkbox
              v-model="answer.isSelected"
              :label="answer.text"
              :disabled="disabled"
              @click.native="toggleSelection(answer.id)"
            />
          </v-flex>
        </v-layout>
      </div>

      <v-layout style="margin-top: 25px;" row wrap>
        <v-flex md12>

          <div v-if="isMeasureListProcessing">
            <v-progress-linear :indeterminate="true"/>
          </div>
          <div v-else>
            <div v-for="(measure, index) in measures" :key="index">
              <v-layout row wrap>
                <v-flex md2>
                  <span v-if="index === 0">Maßnahmen-Notizen:</span>
                </v-flex>
                <v-flex md10>
                  <v-btn small class="opt-btn" @click="onEditMeasureNote(measure)">
                    {{
                      measure.name.length > 95
                        ? measure.name.substring(0, 95) + '...' : measure.name
                    }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md12 style="height: 45px;"/>
      </v-layout>

    </v-container>

    <MeasureNoteDialog
      v-if="isMeasureNoteDialogDisplayed"
      :measure-item-id="measureItemId" :measure-item-note="measureItemNote"
      @cancel="isMeasureNoteDialogDisplayed = false"
    />
  </div>
</template>
